import { Translation } from 'infrastructure/i18n/typing';
import { JitTranslations } from './typing';

export const JitText: Translation<JitTranslations> = {
  es: {
    menuTitle: 'JIT',
    partCoverage: 'Panel JIT',
    emptyMessage: 'No hay datos disponibles.',
    productionPlanUpdate: 'Act. Plan de produccion',
    code: 'Clave',
    providerCode: 'Clave proveedor',
    conType: 'Tipo',
    providerName: 'Nombre prov.',
    providerCoverage: 'Cob. N2',
    providerId: 'Código prov.',
    line: 'Línea',
    dateOfForecastStoppage: 'Previsión de paro',
    models: 'Modelo',
    family: 'Familia',
    type: 'Tipo',
    pr: 'PR',
    typeTooltip:
      '<b>Tipos de flujos</b> de entrega de materiales <b>JIT</b>.<ul><li><b>Syncro:</b> El mismo T1 monta, secuencia y envía material a SEAT</li><li><b>No Syncro:</b> T1 monta y el Operador logístico secuencia y envía material a SEAT</li></ul>',
    margin: 'Tránsitos T2',
    OLName: 'Nombre OL',
    inbounder: 'Inbounder',
    sequencerCoverage: 'Cobertura',
    unitSinglePiece: 'pza.',
    unitMultiplePieces: 'pzas.',
    linesMultiselectAvailable: 'Lineas disponibles',
    linesMultiselectSelected: 'Lineas seleccionadas',
    linesMultiselectEmpty: 'No hay lineas disponibles',
    modelMultiselectAvailable: 'Modelos disponibles',
    modelMultiselectSelected: 'Modelos seleccionados',
    modelMultiselectEmpty: 'No hay modelos disponibles',
    prMultiselectAvailable: 'PR disponibles',
    prMultiselectSelected: 'PR seleccionados',
    prMultiselectEmpty: 'No hay PR disponibles',
    prMultiselectLoading: 'Cargando opciones...',
    familyMultiselectAvailable: 'Familias disponibles',
    familyMultiselectSelected: 'Familias seleccionadas',
    familyMultiselectEmpty: 'No hay familias disponibles',
    providerIdsMultiselectAvailable: 'T1 disponibles',
    providerIdsMultiselectSelected: 'T1 seleccionados',
    providerIdsMultiselectEmpty: 'No hay T1 disponibles',
    sequencerCodeMultiselectAvailable: 'OL disponibles',
    sequencerCodeMultiselectSelected: 'OL seleccionados',
    sequencerCodeMultiselectEmpty: 'No hay OL disponibles',
    inbounderMultiselectAvailable: 'Inbounders disponibles',
    inbounderMultiselectSelected: 'Inbounders seleccionados',
    inbounderMultiselectEmpty: 'No hay inbounders disponibles',
    flowTypes: 'Tipo flujo',
    showMoreFilters: 'Ver más filtros',
    loadFilters: 'Cargar Filtros',
    coverageWithLabel: 'Cobertura con',
    T1Stock2Tooltip:
      'Hasta que día y hora se <b>cubre</b> la producción con <b>T1 stock/Operador logístico</b><ul><li>MAX = producción cubierta > 15 días</li></ul>',
    T2TransitsTooltip:
      'Hasta qué día y hora se <b>cubre</b> la producción con <b>stock del OL + tránsitos del T1 al OL</b><ul><li> MAX = producción cubierta > 15 días</li></ul>',
    all: 'Todos',
    amount: 'Cant.',
    deliveryTime: 'Llegada',
    providerDeliveryNote: 'Albarán',
    plateNumber: 'Matrícula',
    keyUnit: 'Conjunto: ',
    OL: 'OL',
    OLProvider: 'Operador logístico',
    OLProviderTooltip:
      '<b>Nombre del Operador Logístico</b> que secuencia y entrega a Martorell.<br/><br/> En los flujos Syncro no existe Operador logístico.',
    OLStock: 'Stock conjunto',
    OLUpdated: 'Act. Stock',
    OLUpdatedTooltip:
      '<b>Fecha última actualización del stock</b> comunicada por el Operador logístico.',
    T1: 'T1',
    provider: 'Proveedor',
    T1Provider: 'Proveedor T1',
    T1ProviderTooltip:
      '<b>Nombre del proveedor T1</b> que abastece a Martorell.<br/><br/> Si es Syncro secuencia y entrega el material a fábrica.',
    T1Stock: 'Stock conjunto',
    T1Updated: 'Act. Stock',
    T1UpdatedTooltip:
      '<b>Fecha última actualización del stock</b> comunicada por el T1',
    OLCode: 'Código OL',
    description: 'Descripcion',
    providerBusinessName: 'Razón social Proveedor',
    providerBusinessCode: 'Código Proveedor',
    OLBusinessCode: 'Código OL',
    OlBusinessName: 'Razón social OL',
    searcherPlaceholderProgramCoveragePanel:
      'Búsqueda por clave, descripción, nombre del proveedor, código del proveedor o inbounder',
    comment: 'Comentarios',
    editComment: 'Clica en el icono para editar el comentario',
    removeComment: 'Clica en el icono para borrar el comentario',
    updateComment: 'Clica en el icono para actualizar el comentario',
    commentsTooltip:
      'Los comentarios son solamente visibles para los usuarios de aprovisionamiento, los proveedores no ven esta información',
    commentUpdatedSuccess: 'El comentario se ha actualizado con éxito',
    commentRemovedSuccess: 'El comentario se ha eliminado correctamente',
    commentUpdatedFailed:
      'El comentario no se ha podido actualizar, pruebe pasados unos minutos.',
    PrTooltipText: 'Prs asociadas a la clave',
    sequencer_coverage_status: 'Estado',
    boardKeyFilter: 'Clave en Pizarra',
    sequencerCoverageStatusTooltip: `
    <p>Criticidad de paro <<span style="font-weight: bold;">considerando stock en almacén</span>
<ul>
  <li><span style="font-weight: bold;">Estado OK</span> = Cobertura es mayor que el <span style="font-weight: bold;">Stock de Seguridad</span></li>
  <li><span style="font-weight: bold;">Estado NO OK</span> = Cobertura es menor que el <span style="font-weight: bold;">Stock de Seguridad</span></li>
</ul>
</p>`,
    stock_coverage: 'Stock (cantidad)',
    dialogLoadEdit:
      '¿Estás seguro de que queréis modificar este campo de forma permanente?',
    dialogLoadDelete:
      '¿Estás seguro de que queréis eliminar este tránsito de forma permanente?',
    dialogLoadSimulation: '¿Seguro que quieres lanzar la simulación?',
    dialogLoadDefault: '¿Estás seguro de que quieres continuar?',
    runSimulation: 'Ejecutar Simulacion',
    deleteSimulation: 'Eliminar simulacion',
    simulationToolTip: 'Load simulado',
    editLoad: 'Clica en el icono para salvar los cambios en el load',
    removeLoad: 'Clica en el icono para eliminar este load',
    editLoads: {
      amount: 'El importe debe estar entre 1 y 99999',
      deliveryTimeDate:
        'La fecha debe estar en formato dd/mm/yyyy y no ser mayor a un mes desde hoy',
      deliveryTime: 'La hora debe estar en formato hh:mmh',
      providerDeliveryNote: 'La nota no puede superar los 255 caracteres',
      plateNumber: 'La matrícula debe ser válida (ejemplo: ABC-1234 o AB1234)',
      addLoad: 'Añadir Transito',
      addLoadTooltip: 'Pulse para entrar en la creacion este informe transito.',
      dialogAddLoad:
        '¿Estás seguro de que queréis añadir este transito de forma permanente?'
    },
    remarcks: {
      addRemarck: 'añadir informe',
      createRemark: 'crear informe',
      createRemarkTitle: 'Crear informe',
      createRemarkTooltip: 'Pulse para entrar en la creacion este informe.',
      editRemark: 'editar informe',
      editRemarkTitle: 'editar informe',
      editRemarkTooltip: 'Pulse para entrar en la editar este informe.',
      deleteRemark: 'eliminar informe',
      deleteRemarkTooltip: 'Pulse para eliminar este informe.',
      dialogDelete:
        '¿Estás seguro de que queréis eliminar este Informe de forma permanente?',
      downloadRemark: 'descarga informe',
      downloadRemarkTooltip: 'Pulse para descargar este informe.'
    },
    loads: {
      createLoad: 'crear transitos',
      createLoadTitle: 'Crear transitos',
      createLoadTooltip: 'Pulse para entrar en la creacion este transitos.',
      deliveryDateLabel: 'Llegada',
      deliveryTimeLabel: 'Llegada hh:mm',
      editLoadTitle: 'editar transitos',
      editLoadTooltip: 'Pulse para entrar en la editar este transitos.'
    },
    createdAt: 'Creado el',
    modifiedAt: 'Modificado el',
    m100LaunchesCount: 'Lanzamientos M100',
    stockSequence: 'Stock (secuencia)',
    coverageSequence: 'Cobertura (secuencia)',
    coverageStoppedAt: 'Cobertura (fecha y hora)',
    lineStoppedAt: 'Paro línea (fecha y hora)',
    updateFisJIT: 'Act. FIS JIT:',
    updateFismoon: 'Act. FISMOON:',
    slateUpdate: 'Act. Pizarra:',
    hour: 'Hora',
    needsViewLabel: 'Vista necesidades:',
    besiIfa: 'BESI / IFA',
    fisMoon: 'FIS MOON',
    factory: 'Fábrica',
    originLabel: 'Origen:',
    needsSourceSap: 'Necesidades SAP',
    needsSourceFismoon: 'Necesidades FISMOON'
  },
  en: {
    menuTitle: 'JIT',
    partCoverage: 'JIT Panel',
    emptyMessage: 'There is no data available.',
    productionPlanUpdate: 'Act. production plan:',
    code: 'Part',
    providerCode: 'Provider part',
    providerId: 'Provider code',
    conType: 'Type',
    providerName: 'Provider name',
    providerCoverage: 'Cov. N2',
    line: 'Line',
    dateOfForecastStoppage: 'Predicted stop date',
    models: 'Model',
    family: 'Family',
    type: 'Type',
    pr: 'PR',
    typeTooltip:
      '<b>Types of JIT</b> material delivery <b>flows</b>.<ul><li><b>Syncro</b>: T1 himself assembles, sequences and sends material to SEAT</li><li><b>No Syncro</b>: T1 assembles and the Logistics operator sequences and sends material to SEAT</li></ul>',
    margin: 'T2 transits',
    OLName: 'OL Name',
    inbounder: 'Inbounder',
    sequencerCoverage: 'Coverage',
    unitSinglePiece: 'pc',
    unitMultiplePieces: 'pcs',
    linesMultiselectAvailable: 'Lines availables',
    linesMultiselectSelected: 'Lines selected',
    linesMultiselectEmpty: "There aren't lines available",
    modelMultiselectAvailable: 'Models available',
    modelMultiselectSelected: 'Models selected',
    modelMultiselectEmpty: "There aren't models available",
    prMultiselectAvailable: 'PR available',
    prMultiselectSelected: 'PR selected',
    prMultiselectEmpty: "There aren't models available",
    prMultiselectLoading: 'Loading options...',
    familyMultiselectAvailable: 'Families available',
    familyMultiselectSelected: 'Families selected',
    familyMultiselectEmpty: "There aren't families available",
    providerIdsMultiselectAvailable: 'T1 available',
    providerIdsMultiselectSelected: 'T1 selected',
    providerIdsMultiselectEmpty: "There aren't T1 available",
    sequencerCodeMultiselectAvailable: 'OL available',
    sequencerCodeMultiselectSelected: 'OL selected',
    sequencerCodeMultiselectEmpty: "There aren't OL available",
    inbounderMultiselectAvailable: 'Inbounders available',
    inbounderMultiselectSelected: 'Inbounders selected',
    inbounderMultiselectEmpty: "There aren't inbounders available",
    flowTypes: 'Flow type',
    showMoreFilters: 'Show more filters',
    loadFilters: 'Load Filters',
    coverageWithLabel: 'Coverage with',
    T1Stock2Tooltip:
      'Until what day and time is production <b>covered</b> with <b>T1 stock / Logistics operator</b><ul><li>MAX = covered production > 15 days</li></ul>',
    T2TransitsTooltip:
      'Until what day and time is production <b>covered</b> with stock from the <b>OL + transits from T1 to OL</b><ul><li>MAX = covered production > 15 days</li></ul>',
    all: 'All',
    amount: 'Amt.',
    deliveryTime: 'Arrival',
    providerDeliveryNote: 'Prov. D. note',
    plateNumber: 'Plate number',
    keyUnit: 'Key unit: ',
    OL: 'LO',
    OLProvider: 'Logistic operator',
    OLProviderTooltip:
      '<b>Name of the Logistics operator</b> who sequences and delivers to Martorell.<br/><br/> In Syncro flows there is no Logistics operator.',
    OLStock: 'Stock key unit',
    OLUpdated: 'Stock upd.',
    OLUpdatedTooltip:
      '<b>Date of the last stock update</b> communicated by the Logistics operator.',
    T1: 'T1',
    provider: 'Provider',
    T1Provider: 'T1 Provider',
    T1ProviderTooltip:
      '<b>Name of the T1 supplier</b> that supplies Martorell.<br/><br/> If it is Syncro, sequence and deliver the material to the factory.',
    T1Stock: 'Key unit stock',
    T1Updated: 'Stock upd.',
    T1UpdatedTooltip: '<b>Date last stock update</b> reported by the T1',
    OLCode: 'OL Code',
    description: 'Description',
    providerBusinessName: 'Provider Business Name',
    providerBusinessCode: 'Provider Code',
    OLBusinessCode: 'OL Code',
    OlBusinessName: 'OL Business Name',
    searcherPlaceholderProgramCoveragePanel:
      'Search by key, description, provider name, provider code or inbounder',
    comment: 'Comments',
    editComment: 'Click on the icon to edit the comment',
    removeComment: 'Click on the icon to remove the comment',
    updateComment: 'Click on the icon to update the comment',
    commentsTooltip:
      'Comments are only visible to provisioning users, suppliers do not see this information',
    commentUpdatedSuccess: 'Comment has been updated successfully',
    commentRemovedSuccess: 'Comment has been successfully deleted',
    commentUpdatedFailed:
      'The comment could not be updated, try after a few minutes.',
    PrTooltipText: 'PRs associated with the key',
    sequencer_coverage_status: 'Status',
    boardKeyFilter: 'Key in Board',
    sequencerCoverageStatusTooltip: `
    <p>Shutdown criticality <span style="font-weight: bold;">considering warehouse stock</span></p>
<ul>
  <li><span style="font-weight: bold;">OK Status</span> = Coverage is greater than the <span style="font-weight: bold;">Safety Stock</span> </li>
  <li><span style="font-weight: bold;">NOT OK Status</span> = Coverage is less than the <span style="font-weight: bold;">Safety Stock</span></li>
</ul>`,
    stock_coverage: 'Stock (quantity)',
    dialogLoadEdit: 'Are you sure you want to permanently modify this field?',
    dialogLoadDelete:
      'Are you sure you want to permanently delete this transit?',
    dialogLoadSimulation: 'Are you sure you want to run the simulation?',
    dialogLoadDefault: 'Are you sure you want to continue?',
    runSimulation: 'Run Simulation',
    deleteSimulation: 'Delete simulation',
    simulationToolTip: 'Simulated Load',
    editLoad: 'Click the icon to save the changes to the load',
    removeLoad: 'Click the icon to delete this load',
    editLoads: {
      amount: 'The amount must be between 1 and 99999',
      deliveryTimeDate:
        'The date must be in dd/mm/yyyy format and no more than one month from today',
      deliveryTime: 'The time must be in hh:mmh format',
      providerDeliveryNote: 'The note cannot exceed 255 characters',
      plateNumber:
        'The license plate must be valid (example: ABC-1234 or AB1234)',
      addLoad: 'Add transit',
      addLoadTooltip: 'Click to create this transit report.',
      dialogAddLoad: 'Are you sure you want to permanently add this transit?'
    },
    remarcks: {
      addRemarck: 'add report',
      createRemark: 'create report',
      createRemarkTitle: 'Create report',
      createRemarkTooltip: 'Click to create this report.',
      editRemark: 'edit report',
      editRemarkTitle: 'Edit report',
      editRemarkTooltip: 'Click to edit this report.',
      deleteRemark: 'delete report',
      deleteRemarkTooltip: 'Click to delete this report.',
      dialogDelete: 'Are you sure you want to permanently delete this Remark?',
      downloadRemark: 'download report',
      downloadRemarkTooltip: 'Click to download this report.'
    },
    loads: {
      createLoad: 'Create transit',
      createLoadTitle: 'Create transit',
      createLoadTooltip: 'Click to create this report transit.',
      deliveryDateLabel: 'Arrival',
      deliveryTimeLabel: 'Arrival hh:mm',
      editLoadTitle: 'Edit transit',
      editLoadTooltip: 'Click to edit this report transit.'
    },
    m100LaunchesCount: 'M100 Launches',
    stockSequence: 'Stock (sequence)',
    coverageSequence: 'Coverage (sequence)',
    coverageStoppedAt: 'Coverage (date & time)',
    lineStoppedAt: 'Line stoppage (date & time)',
    createdAt: 'Created at',
    modifiedAt: 'Modified at',
    updateFisJIT: 'Act. FIS JIT:',
    updateFismoon: 'Act. FISMOON:',
    slateUpdate: 'Act.  Pizarra:',
    hour: 'Hour',
    needsViewLabel: 'Needs view:',
    besiIfa: 'BESI / IFA',
    fisMoon: 'FIS MOON',
    factory: 'Factory',
    originLabel: 'Source:',
    needsSourceSap: 'SAP needs',
    needsSourceFismoon: 'FISMOON needs'
  },
  ca: {
    menuTitle: 'JIT',
    partCoverage: 'Panell JIT',
    emptyMessage: 'No hi ha dades disponibles.',
    productionPlanUpdate: 'Act. pla producció:',
    code: 'Clau',
    providerCode: 'Clau proveïdor',
    providerId: 'Codi prov.',
    conType: 'Tipus',
    providerName: 'Nom prov.',
    providerCoverage: 'Cob. N2',
    line: 'Línia',
    dateOfForecastStoppage: 'Previsió de parada',
    models: 'Model',
    family: 'Familia',
    type: 'Tipus',
    pr: 'PR',
    typeTooltip:
      "<b>Syncro:</b> Proveïdor Tier 2 i Tier 1 són els mateixos, munta i seqüència. <br/><b>No Syncro:</b> Proveïdor Tier 2 munta i l'Operador logístic seqüència.",
    margin: 'Trànsits T2',
    OLName: 'Nom OL',
    inbounder: 'Inbounder',
    sequencerCoverage: 'Cobertura',
    unitSinglePiece: 'peça',
    unitMultiplePieces: 'peces',
    linesMultiselectAvailable: 'Línies disponibles',
    linesMultiselectSelected: 'Línies seleccionades',
    linesMultiselectEmpty: 'No hi ha línies disponibles',
    modelMultiselectAvailable: 'Models disponibles',
    modelMultiselectSelected: 'Models seleccionats',
    modelMultiselectEmpty: 'No hi ha models disponibles',
    prMultiselectAvailable: 'PR disponibles',
    prMultiselectSelected: 'PR seleccionats',
    prMultiselectEmpty: 'No hi ha PR disponibles',
    prMultiselectLoading: 'Carregant opcions ...',
    familyMultiselectAvailable: 'Famílies disponibles',
    familyMultiselectSelected: 'Famílies seleccionades',
    familyMultiselectEmpty: 'No hi ha familíes disponibles',
    providerIdsMultiselectAvailable: 'T1 disponibles',
    providerIdsMultiselectSelected: 'T1 seleccionades',
    providerIdsMultiselectEmpty: 'No hi ha T1 disponibles',
    sequencerCodeMultiselectAvailable: 'OL disponibles',
    sequencerCodeMultiselectSelected: 'OL seleccionades',
    sequencerCodeMultiselectEmpty: 'No hi ha OL disponibles',
    inbounderMultiselectAvailable: 'Inbounders disponibles',
    inbounderMultiselectSelected: 'Inbounders seleccionats',
    inbounderMultiselectEmpty: 'No hi ha inbounders disponibles',
    flowTypes: 'Tipus flux',
    showMoreFilters: 'Veure més filtres',
    loadFilters: 'Carregar Filtres',
    coverageWithLabel: 'Cobertura amb',
    T1Stock2Tooltip:
      'Fins que dia i hora es <b>cobreix</b> la producció amb <b>T1 estoc / Operador logístic</b><ul><li> MAX = producció coberta > 15 dies</li></ul>',
    T2TransitsTooltip:
      "Fins a quin dia i hora es <b>cobreix</b> la producció amb estoc de l'<b>OL + trànsits del T1 a l'OL</b><ul><li>MAX = producció coberta > 15 dies</li></ul>",
    all: 'Tots',
    amount: 'Quant.',
    deliveryTime: 'Arribada',
    providerDeliveryNote: 'Albarà',
    plateNumber: 'Matrícula',
    keyUnit: 'Conjunt: ',
    OL: 'OL',
    OLProvider: 'Operador logístic',
    OLProviderTooltip:
      "<b>Nom de l'Operador logístic</b> que seqüencia i lliura a Martorell.<br/><br/>Als fluxos Syncro no hi ha Operador logístic.",
    OLStock: 'Estoc conjunt',
    OLUpdated: 'Act. estoc',
    OLUpdatedTooltip:
      "<b>Data darrera actualització de l'estoc</b> comunicada per l'Operador logístic.",
    T1: 'T1',
    provider: 'Proveïdor',
    T1Provider: 'Proveïdor T1',
    T1ProviderTooltip:
      '<b>Nom del proveïdor T1</b> que abasta Martorell.<br/><br/> Si és Syncro seqüència i lliura el material a fàbrica.',
    T1Stock: 'Estoc conjunt',
    T1Updated: 'Act. estoc',
    T1UpdatedTooltip:
      "<b>Data de la darrera actualització de l'estoc</b> comunicada pel T1",
    OLCode: 'Codi OL',
    description: 'Descripció',
    providerBusinessName: 'Raó social del proveïdor',
    providerBusinessCode: 'COdi Proveïdor',
    OLBusinessCode: 'Codi OL',
    OlBusinessName: "Raó social de l'OL",
    searcherPlaceholderProgramCoveragePanel:
      'Cerca per clau, descripció, nom del proveïdor, codi del proveïdor o inbounder',
    comment: 'Comentaris',
    editComment: 'Clica a la icona per editar el comentari',
    removeComment: 'Clica a la icona per esborrar el comentari',
    updateComment: 'Clica a la icona per actualitzar el comentari',
    commentsTooltip:
      'Els comentaris són només visibles per als usuaris de proveïment, els proveïdors no veuen aquesta informació',
    commentUpdatedSuccess: 'El comentari ha estat actualitzat amb èxit',
    commentRemovedSuccess: "El comentari s'ha eliminat correctament",
    commentUpdatedFailed:
      "El comentari no s'ha pogut actualitzar, proveu passats uns minuts.",
    PrTooltipText: 'PRs associades a la clau',
    sequencer_coverage_status: 'Estat',
    boardKeyFilter: 'Key in Board',
    sequencerCoverageStatusTooltip: `
    <p>Criticitat d'aturada <span style="font-weight: bold;">considerant estoc a magatzem</span></p>
<ul>
  <li><span style="font-weight: bold;">Estat OK</span> = La cobertura és superior a l'<span style="font-weight: bold;">Estoc de Seguretat</span></li>
  <li><span style="font-weight: bold;">Estat NO OK</span> = La cobertura és inferior a l'<span style="font-weight: bold;">Estoc de Seguretat</span></li>
</ul>`,
    stock_coverage: 'Stock (quantitat)',
    dialogLoadEdit:
      'Estàs segur que vols modificar aquest camp de manera permanent?',
    dialogLoadDelete:
      'Estàs segur que vols eliminar aquest trànsit de manera permanent?',
    dialogLoadSimulation: 'Estàs segur que vols llançar la simulació?',
    dialogLoadDefault: 'Estàs segur que vols continuar?',
    runSimulation: 'Run Simulation',
    deleteSimulation: 'Delete simulation',
    simulationToolTip: 'Càrrega simulada',
    editLoad: 'Fes clic a la icona per desar els canvis del load',
    removeLoad: 'Fes clic a la icona per eliminar aquest load',
    editLoads: {
      amount: 'L’import ha d’estar entre 1 i 99999',
      deliveryTimeDate:
        'La data ha d’estar en format dd/mm/aaaa i no pot ser superior a un mes des d’avui',
      deliveryTime: 'L’hora ha d’estar en format hh:mmh',
      providerDeliveryNote: 'La nota no pot superar els 255 caràcters',
      plateNumber: 'La matrícula ha de ser vàlida (exemple: ABC-1234 o AB1234)',
      addLoad: 'Afegir trànsit',
      addLoadTooltip: 'Prem per crear aquest informe de trànsit.',
      dialogAddLoad:
        'Estàs segur que vols afegir aquest trànsit de manera permanent?'
    },
    remarcks: {
      addRemarck: 'afegir informe',
      createRemark: 'crear informe',
      createRemarkTitle: 'Crear informe',
      createRemarkTooltip: 'Prem per crear aquest informe.',
      editRemark: 'editar informe',
      editRemarkTitle: 'Editar informe',
      editRemarkTooltip: 'Prem per editar aquest informe.',
      deleteRemark: 'eliminar informe',
      deleteRemarkTooltip: 'Prem per eliminar aquest informe.',
      dialogDelete:
        'Estàs segur que vols eliminar aquest informe de manera permanent?',
      downloadRemark: 'descarregar informe',
      downloadRemarkTooltip: 'Prem per descarregar aquest informe.'
    },
    loads: {
      createLoad: 'crear transit',
      createLoadTitle: 'crear transit',
      createLoadTooltip: 'Prem per crear aquest transit.',
      deliveryDateLabel: 'Arribada',
      deliveryTimeLabel: 'Arribada hh:mm',
      editLoadTitle: 'editar transit',
      editLoadTooltip: 'Prem per editar aquest transit.'
    },
    m100LaunchesCount: 'Llançaments M100',
    stockSequence: 'Estoc (seqüència)',
    coverageSequence: 'Cobertura (seqüència)',
    coverageStoppedAt: 'Cobertura (data i hora)',
    lineStoppedAt: 'Aturada línia (data i hora)',
    createdAt: 'Creat el',
    modifiedAt: 'Modificat el',
    updateFisJIT: 'Act. FIS JIT:',
    updateFismoon: 'Act. FISMOON:',
    slateUpdate: 'Act.  Pizarra:',
    hour: 'Hora',
    needsViewLabel: 'Vista necessitats:',
    besiIfa: 'BESI / IFA',
    fisMoon: 'FIS MOON',
    factory: 'Fàbrica',
    originLabel: 'Origen:',
    needsSourceSap: 'Necessitats SAP',
    needsSourceFismoon: 'Necessitats FISMOON'
  }
};
